import {
  CaiDatLoaiGiaTri,
  ICaiDatItem,
  ICaiDatTuyChon,
} from '@/core/interfaces/ApiResponses';

export const BLOCKED_KHOA_PREFIXES = [
  'KHO_CHECKPOINT_DATE_',
  'KHO_INITIAL_BALANCE_DATE_',
];

export const LOAI_GIA_TRI_OPTIONS: Array<{
  value: CaiDatLoaiGiaTri;
  label: string;
}> = [
  { value: 'text', label: 'Text' },
  { value: 'textarea', label: 'Textarea' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'dropdown', label: 'Dropdown' },
];

export const normalizeCaiDatItem = (item: ICaiDatItem): ICaiDatItem => ({
  ...item,
  loai_gia_tri: item.loai_gia_tri || 'text',
  tuy_chon: Array.isArray(item.tuy_chon) ? item.tuy_chon : [],
});

export const defaultGiaTriForLoai = (loai: CaiDatLoaiGiaTri): string => {
  if (loai === 'boolean') return '0';
  return '';
};

export const loaiGiaTriLabel = (loai?: CaiDatLoaiGiaTri): string =>
  LOAI_GIA_TRI_OPTIONS.find((option) => option.value === loai)?.label ||
  loai ||
  'Text';

export const formatGiaTriDisplay = (item: ICaiDatItem): string => {
  const value = item.gia_tri;
  if (value === null || value === undefined || value === '') return '-';

  if (item.loai_gia_tri === 'boolean') {
    return value === '1' ? 'Bật' : 'Tắt';
  }

  if (item.loai_gia_tri === 'dropdown') {
    const matched = (item.tuy_chon || []).find((opt) => opt.value === value);
    return matched?.label || value;
  }

  return value;
};

export const filterValidTuyChon = (
  options: ICaiDatTuyChon[]
): ICaiDatTuyChon[] =>
  options
    .map((opt) => ({
      value: opt.value.trim(),
      label: opt.label.trim(),
    }))
    .filter((opt) => opt.value !== '' && opt.label !== '');
